/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../api/capture';
import '../api/legacy_refund';
import '../api/reverse';
import '../api/set_metadata';
import '../api/push_money';
import '../api/set_refund_metadata';
import '../api/fee_events';
import '../api/complete_or_cancel_recorded';
import '../api/finalize_bank_transaction';
import '../api/complete_async_transaction';
import '../api/fail_async_transaction';
import '../api/payment_recovery';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "Type": {
                "values": {
                  "DEFAULT_TYPE": 0,
                  "CAPTURE": 1,
                  "REFUND": 2,
                  "REVERSE": 3,
                  "SET_METADATA": 4,
                  "SET_REFUND_METADATA": 5,
                  "COMPLETE_OR_CANCEL_RECORDED": 6,
                  "FINALIZE_BANK_TRANSACTION": 7,
                  "COMPLETE_ASYNC_TRANSACTION": 8,
                  "FAIL_ASYNC_TRANSACTION": 9,
                  "PAYMENT_RECOVERY": 10
                }
              },
              "Request": {
                "fields": {
                  "requestId": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.esperanto.model.Type",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "captureRequest": {
                    "type": ".squareup.esperanto.api.CaptureRequest",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundRequest": {
                    "type": ".squareup.esperanto.api.RefundRequest",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reverseRequest": {
                    "type": ".squareup.esperanto.api.ReverseRequest",
                    "id": 6,
                    "rule": "optional"
                  },
                  "setMetadataRequest": {
                    "type": ".squareup.esperanto.api.SetMetadataRequest",
                    "id": 7,
                    "rule": "optional"
                  },
                  "pushMoneyRequest": {
                    "type": ".squareup.esperanto.api.PushMoneyRequest",
                    "id": 8,
                    "rule": "optional"
                  },
                  "setRefundMetadataRequest": {
                    "type": ".squareup.esperanto.api.SetRefundMetadataRequest",
                    "id": 9,
                    "rule": "optional"
                  },
                  "addFeeEventsRequest": {
                    "type": ".squareup.esperanto.api.AddFeeEventsRequest",
                    "id": 10,
                    "rule": "optional"
                  },
                  "completeCancelRecordedRequest": {
                    "type": ".squareup.esperanto.api.CompleteOrCancelRecordedTransactionRequest",
                    "id": 11,
                    "rule": "optional"
                  },
                  "finalizeBankTransactionRequest": {
                    "type": ".squareup.esperanto.api.FinalizeBankTransactionRequest",
                    "id": 12,
                    "rule": "optional"
                  },
                  "completeAsyncTransactionRequest": {
                    "type": ".squareup.esperanto.api.CompleteAsyncTransactionRequest",
                    "id": 13,
                    "rule": "optional"
                  },
                  "failAsyncTransactionRequest": {
                    "type": ".squareup.esperanto.api.FailAsyncTransactionRequest",
                    "id": 14,
                    "rule": "optional"
                  },
                  "paymentRecoveryRequest": {
                    "type": ".squareup.esperanto.api.PaymentRecoveryRequest",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "Response": {
                "fields": {
                  "type": {
                    "type": ".squareup.esperanto.model.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "captureResponse": {
                    "type": ".squareup.esperanto.api.CaptureResponse",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundResponse": {
                    "type": ".squareup.esperanto.api.RefundResponse",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reverseResponse": {
                    "type": ".squareup.esperanto.api.ReverseResponse",
                    "id": 5,
                    "rule": "optional"
                  },
                  "setMetadataResponse": {
                    "type": ".squareup.esperanto.api.SetMetadataResponse",
                    "id": 6,
                    "rule": "optional"
                  },
                  "pushMoneyResponse": {
                    "type": ".squareup.esperanto.api.PushMoneyResponse",
                    "id": 7,
                    "rule": "optional"
                  },
                  "setRefundMetadataResponse": {
                    "type": ".squareup.esperanto.api.SetRefundMetadataResponse",
                    "id": 8,
                    "rule": "optional"
                  },
                  "addFeeEventsResponse": {
                    "type": ".squareup.esperanto.api.AddFeeEventsResponse",
                    "id": 9,
                    "rule": "optional"
                  },
                  "completeCancelRecordedResponse": {
                    "type": ".squareup.esperanto.api.CompleteOrCancelRecordedTransactionResponse",
                    "id": 10,
                    "rule": "optional"
                  },
                  "finalizeBankTransactionResponse": {
                    "type": ".squareup.esperanto.api.FinalizeBankTransactionResponse",
                    "id": 11,
                    "rule": "optional"
                  },
                  "completeAsyncTransactionResponse": {
                    "type": ".squareup.esperanto.api.CompleteAsyncTransactionResponse",
                    "id": 12,
                    "rule": "optional"
                  },
                  "failAsyncTransactionResponse": {
                    "type": ".squareup.esperanto.api.FailAsyncTransactionResponse",
                    "id": 13,
                    "rule": "optional"
                  },
                  "paymentRecoveryResponse": {
                    "type": ".squareup.esperanto.api.PaymentRecoveryResponse",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "LogEntry": {
                "fields": {
                  "request": {
                    "type": ".squareup.esperanto.model.Request",
                    "id": 1,
                    "rule": "optional"
                  },
                  "response": {
                    "type": ".squareup.esperanto.model.Response",
                    "id": 2,
                    "rule": "optional"
                  },
                  "hasSucceed": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "retries": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Type && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Request && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Response && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.LogEntry) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Type @ squareup/esperanto/model/sync.proto at 21:1
 */
export const Type = $root.lookupEnum('squareup.esperanto.model.Type').values;
/**
 * SOURCE Request @ squareup/esperanto/model/sync.proto at 36:1
 */
export const Request = $root.lookupType('squareup.esperanto.model.Request');
fixType(Request, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(Request);
/**
 * SOURCE Response @ squareup/esperanto/model/sync.proto at 83:1
 */
export const Response = $root.lookupType('squareup.esperanto.model.Response');
fixType(Response);
Builder.createAndAttachToType(Response);
/**
 * SOURCE LogEntry @ squareup/esperanto/model/sync.proto at 113:1
 */
export const LogEntry = $root.lookupType('squareup.esperanto.model.LogEntry');
fixType(LogEntry);
Builder.createAndAttachToType(LogEntry);